<header class="header">
  <nav class="navbar navbar-expand-lg header-navbar">
    <a class="navbar-brand header-brand">
      <img
        [src]="
          matchInfo.teamHome?.logo
            ? matchInfo.teamHome?.logo
            : 'assets/images/placeholder-img.jpg'
        "
        alt="home team logo"
        class="image"
      />

      <span>
        <svg
          width="28"
          height="21"
          viewBox="0 0 28 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.43355 0.262207L6.40673 12.972L12.9109 0.262207H17.3445L8.2581 17.0967H3.04502L0 0.262207H4.43355Z"
            fill="#C7C9D9"
          />
          <path
            d="M20.5458 20.2622C18.6944 20.2622 17.1841 19.8705 16.0148 19.0871C14.8617 18.2878 14.2852 17.1607 14.2852 15.7059C14.2852 15.562 14.3015 15.3461 14.3339 15.0584H18.6701C18.6213 15.6659 18.7675 16.1455 19.1085 16.4972C19.4496 16.8489 19.9693 17.0248 20.6676 17.0248C21.3009 17.0248 21.7963 16.8889 22.1536 16.6171C22.5271 16.3453 22.7138 15.9616 22.7138 15.466C22.7138 14.9545 22.4784 14.5388 22.0074 14.219C21.5527 13.8993 20.8381 13.5396 19.8637 13.1399C18.9218 12.7562 18.1504 12.3965 17.5495 12.0608C16.9648 11.709 16.4533 11.2374 16.0148 10.6459C15.5763 10.0544 15.3571 9.31097 15.3571 8.41568C15.3408 7.31257 15.6169 6.35333 16.1853 5.53799C16.7537 4.72264 17.5414 4.09914 18.5483 3.66748C19.5551 3.23583 20.7082 3.02 22.0074 3.02C23.1767 3.02 24.2161 3.20385 25.1255 3.57156C26.0349 3.92328 26.7414 4.44286 27.2448 5.13031C27.7483 5.80177 28 6.60114 28 7.52839C28 7.7682 27.9919 7.94406 27.9756 8.05597H23.5421C23.5583 7.99202 23.5664 7.8961 23.5664 7.7682C23.5664 7.32056 23.404 6.96085 23.0792 6.68907C22.7707 6.4013 22.3403 6.25741 21.7882 6.25741C21.2035 6.25741 20.7244 6.4013 20.3509 6.68907C19.9936 6.96085 19.815 7.33655 19.815 7.81616C19.815 8.29578 20.0423 8.70345 20.4971 9.03919C20.9518 9.35893 21.6582 9.73463 22.6164 10.1663C23.5746 10.5979 24.3541 10.9976 24.955 11.3653C25.5721 11.733 26.0999 12.2286 26.5384 12.8521C26.9769 13.4596 27.1961 14.211 27.1961 15.1063C27.1961 16.0975 26.9282 16.9848 26.3922 17.7682C25.8563 18.5516 25.0849 19.1671 24.078 19.6147C23.0711 20.0464 21.8937 20.2622 20.5458 20.2622Z"
            fill="#C7C9D9"
          />
        </svg>
      </span>

      <img
        [src]="
          matchInfo.teamAway?.logo
            ? matchInfo.teamAway?.logo
            : 'assets/images/placeholder-img.jpg'
        "
        alt="home team logo"
        class="image"
      />

      <p *ngIf="!isMobile" class="title">
        {{ helpers.getElementTranslatedName(matchInfo.champion) }}
      </p>
    </a>

    <!-- <button
      class="navbar-toggler header-togglerBtn"
      aria-label="toggle menu"
      type="button"
      (click)="isMenuCollapsed = !isMenuCollapsed"
    >
      <i class="fas fa-bars"></i>
    </button> -->

    <div
      *ngIf="!isMobile"
      class="collapse"
      [ngbCollapse]="!isMenuCollapsed"
      style="justify-content: end"
    >
      <ul class="navbar-nav header-menu body">
        <div class="stadium text-start">
          <p class="d-inline-flex">
            <svg
              width="24"
              height="25"
              viewBox="0 0 25 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 6.01221C7.59 6.01221 7.25 5.67221 7.25 5.26221V2.26221C7.25 1.85221 7.59 1.51221 8 1.51221C8.41 1.51221 8.75 1.85221 8.75 2.26221V5.26221C8.75 5.67221 8.41 6.01221 8 6.01221Z"
                fill="white"
              />
              <path
                d="M16 6.01221C15.59 6.01221 15.25 5.67221 15.25 5.26221V2.26221C15.25 1.85221 15.59 1.51221 16 1.51221C16.41 1.51221 16.75 1.85221 16.75 2.26221V5.26221C16.75 5.67221 16.41 6.01221 16 6.01221Z"
                fill="white"
              />
              <path
                d="M8.5 14.762C8.37 14.762 8.24 14.732 8.12 14.682C7.99 14.632 7.89 14.562 7.79 14.472C7.61 14.282 7.5 14.032 7.5 13.762C7.5 13.632 7.53 13.502 7.58 13.382C7.63 13.262 7.7 13.152 7.79 13.052C7.89 12.962 7.99 12.892 8.12 12.842C8.48 12.692 8.93 12.772 9.21 13.052C9.39 13.242 9.5 13.502 9.5 13.762C9.5 13.822 9.49 13.892 9.48 13.962C9.47 14.022 9.45 14.082 9.42 14.142C9.4 14.202 9.37 14.262 9.33 14.322C9.3 14.372 9.25 14.422 9.21 14.472C9.02 14.652 8.76 14.762 8.5 14.762Z"
                fill="white"
              />
              <path
                d="M12 14.7621C11.87 14.7621 11.74 14.7321 11.62 14.6821C11.49 14.6321 11.39 14.5621 11.29 14.4721C11.11 14.2821 11 14.0321 11 13.7621C11 13.6321 11.03 13.5021 11.08 13.3821C11.13 13.2621 11.2 13.1521 11.29 13.0521C11.39 12.9621 11.49 12.8921 11.62 12.8421C11.98 12.6821 12.43 12.7721 12.71 13.0521C12.89 13.2421 13 13.5021 13 13.7621C13 13.8221 12.99 13.8921 12.98 13.9621C12.97 14.0221 12.95 14.0821 12.92 14.1421C12.9 14.2021 12.87 14.2621 12.83 14.3221C12.8 14.3721 12.75 14.4221 12.71 14.4721C12.52 14.6521 12.26 14.7621 12 14.7621Z"
                fill="white"
              />
              <path
                d="M15.5 14.7621C15.37 14.7621 15.24 14.7321 15.12 14.6821C14.99 14.6321 14.89 14.5621 14.79 14.4721C14.75 14.4221 14.71 14.3721 14.67 14.3221C14.63 14.2621 14.6 14.2021 14.58 14.1421C14.55 14.0821 14.53 14.0221 14.52 13.9621C14.51 13.8921 14.5 13.8221 14.5 13.7621C14.5 13.5021 14.61 13.2421 14.79 13.0521C14.89 12.9621 14.99 12.8921 15.12 12.8421C15.49 12.6821 15.93 12.7721 16.21 13.0521C16.39 13.2421 16.5 13.5021 16.5 13.7621C16.5 13.8221 16.49 13.8921 16.48 13.9621C16.47 14.0221 16.45 14.0821 16.42 14.1421C16.4 14.2021 16.37 14.2621 16.33 14.3221C16.3 14.3721 16.25 14.4221 16.21 14.4721C16.02 14.6521 15.76 14.7621 15.5 14.7621Z"
                fill="white"
              />
              <path
                d="M8.5 18.2624C8.37 18.2624 8.24 18.2324 8.12 18.1824C8 18.1324 7.89 18.0624 7.79 17.9724C7.61 17.7824 7.5 17.5224 7.5 17.2624C7.5 17.1324 7.53 17.0024 7.58 16.8824C7.63 16.7524 7.7 16.6424 7.79 16.5524C8.16 16.1824 8.84 16.1824 9.21 16.5524C9.39 16.7424 9.5 17.0024 9.5 17.2624C9.5 17.5224 9.39 17.7824 9.21 17.9724C9.02 18.1524 8.76 18.2624 8.5 18.2624Z"
                fill="white"
              />
              <path
                d="M12 18.2624C11.74 18.2624 11.48 18.1524 11.29 17.9724C11.11 17.7824 11 17.5224 11 17.2624C11 17.1324 11.03 17.0024 11.08 16.8824C11.13 16.7524 11.2 16.6424 11.29 16.5524C11.66 16.1824 12.34 16.1824 12.71 16.5524C12.8 16.6424 12.87 16.7524 12.92 16.8824C12.97 17.0024 13 17.1324 13 17.2624C13 17.5224 12.89 17.7824 12.71 17.9724C12.52 18.1524 12.26 18.2624 12 18.2624Z"
                fill="white"
              />
              <path
                d="M15.5 18.2621C15.24 18.2621 14.98 18.1521 14.79 17.9721C14.7 17.8821 14.63 17.7721 14.58 17.6421C14.53 17.5221 14.5 17.3921 14.5 17.2621C14.5 17.1321 14.53 17.0021 14.58 16.8821C14.63 16.7521 14.7 16.6421 14.79 16.5521C15.02 16.3221 15.37 16.2121 15.69 16.2821C15.76 16.2921 15.82 16.3121 15.88 16.3421C15.94 16.3621 16 16.3921 16.06 16.4321C16.11 16.4621 16.16 16.5121 16.21 16.5521C16.39 16.7421 16.5 17.0021 16.5 17.2621C16.5 17.5221 16.39 17.7821 16.21 17.9721C16.02 18.1521 15.76 18.2621 15.5 18.2621Z"
                fill="white"
              />
              <path
                d="M20.5 10.1021H3.5C3.09 10.1021 2.75 9.76205 2.75 9.35205C2.75 8.94205 3.09 8.60205 3.5 8.60205H20.5C20.91 8.60205 21.25 8.94205 21.25 9.35205C21.25 9.76205 20.91 10.1021 20.5 10.1021Z"
                fill="white"
              />
              <path
                d="M16 23.0122H8C4.35 23.0122 2.25 20.9122 2.25 17.2622V8.76221C2.25 5.11221 4.35 3.01221 8 3.01221H16C19.65 3.01221 21.75 5.11221 21.75 8.76221V17.2622C21.75 20.9122 19.65 23.0122 16 23.0122ZM8 4.51221C5.14 4.51221 3.75 5.90221 3.75 8.76221V17.2622C3.75 20.1222 5.14 21.5122 8 21.5122H16C18.86 21.5122 20.25 20.1222 20.25 17.2622V8.76221C20.25 5.90221 18.86 4.51221 16 4.51221H8Z"
                fill="white"
              />
            </svg>

            {{
              matchInfo.date
                | localizedDate : "dd MMM, y" : translate.currentLang
            }}
          </p>
          <p class="d-inline-flex">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 23.0122C6.07 23.0122 1.25 18.1922 1.25 12.2622C1.25 6.33221 6.07 1.51221 12 1.51221C17.93 1.51221 22.75 6.33221 22.75 12.2622C22.75 18.1922 17.93 23.0122 12 23.0122ZM12 3.01221C6.9 3.01221 2.75 7.16221 2.75 12.2622C2.75 17.3622 6.9 21.5122 12 21.5122C17.1 21.5122 21.25 17.3622 21.25 12.2622C21.25 7.16221 17.1 3.01221 12 3.01221Z"
                fill="white"
              />
              <path
                d="M15.71 16.192C15.58 16.192 15.45 16.162 15.33 16.082L12.23 14.232C11.46 13.772 10.89 12.762 10.89 11.872V7.77197C10.89 7.36197 11.23 7.02197 11.64 7.02197C12.05 7.02197 12.39 7.36197 12.39 7.77197V11.872C12.39 12.232 12.69 12.762 13 12.942L16.1 14.792C16.46 15.002 16.57 15.462 16.36 15.822C16.21 16.062 15.96 16.192 15.71 16.192Z"
                fill="white"
              />
            </svg>

            {{ matchInfo.time ? helpers.convertToAMPM(matchInfo.time) : "" }}
          </p>
          <p class="d-inline-flex">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.34506 19.4894C7.17934 19.3486 5.41373 19.006 4.04823 18.4617C2.68272 17.9174 1.99997 17.3111 1.99997 16.6428V7.8497C1.99997 7.48232 2.24098 7.14134 2.723 6.82676C3.20503 6.51217 3.8756 6.24081 4.73471 6.01267C5.59384 5.78451 6.61679 5.6024 7.80356 5.46633C8.99035 5.33025 10.2797 5.26221 11.6716 5.26221C13.0636 5.26221 14.3496 5.3294 15.5298 5.4638C16.71 5.59817 17.733 5.78028 18.5987 6.01013C19.4644 6.23996 20.1382 6.51217 20.6203 6.82676C21.1023 7.14134 21.3433 7.48232 21.3433 7.8497V16.6435C21.3433 17.3222 20.6561 17.931 19.2818 18.4698C17.9075 19.0087 16.138 19.3486 13.9733 19.4894C13.7575 19.507 13.5752 19.441 13.4263 19.2912C13.2775 19.1415 13.203 18.9605 13.203 18.7481V15.1004H10.1402V18.7217C10.1402 18.9349 10.0617 19.1205 9.90457 19.2787C9.74745 19.4368 9.56095 19.507 9.34506 19.4894ZM11.6716 9.06427C13.2585 9.06427 14.7259 8.97084 16.0739 8.78398C17.4218 8.59713 18.4776 8.30669 19.2413 7.91267C18.8974 7.52405 17.9661 7.21398 16.4476 6.98246C14.9291 6.75092 13.3371 6.63515 11.6716 6.63515C9.95338 6.63515 8.34819 6.74652 6.85608 6.96926C5.36394 7.19198 4.44591 7.50645 4.10198 7.91267C4.86565 8.30669 5.88252 8.59713 7.15259 8.78398C8.42265 8.97084 9.929 9.06427 11.6716 9.06427ZM8.7673 18.0616V15.4214C8.7673 14.9515 8.93369 14.5517 9.26646 14.222C9.59922 13.8923 9.99609 13.7275 10.4571 13.7275H12.8862C13.3472 13.7275 13.744 13.8938 14.0768 14.2266C14.4096 14.5594 14.576 14.9563 14.576 15.4172V18.0616C15.7431 17.9628 16.8175 17.7712 17.7992 17.4869C18.7809 17.2025 19.5046 16.8694 19.9704 16.4876V9.12719C18.9251 9.58891 17.7001 9.92268 16.2956 10.1285C14.8911 10.3343 13.3458 10.4372 11.6598 10.4372C9.97381 10.4372 8.43249 10.3343 7.03583 10.1285C5.63917 9.92268 4.41819 9.58891 3.37288 9.12719V16.4876C3.80347 16.8518 4.50248 17.1805 5.46991 17.4737C6.43736 17.7668 7.53649 17.9628 8.7673 18.0616Z"
                fill="white"
                stroke="white"
                stroke-width="0.2"
              />
            </svg>

            {{
              matchInfo.stadium
                ? helpers.getElementTranslatedName(matchInfo.stadium)
                : ""
            }}
          </p>
        </div>
      </ul>
    </div>
  </nav>
</header>
